import React from 'react';
import ImagenSpc from './ImagenSpc';

/*
  Sección "Listo para instalar": instalación flotante sin retirar la superficie anterior.
  Imagen nueva: /assets/img/productos/pisos-spc-premium/instalacion-flotante-spc.jpg
  (reemplaza a la foto de sala que había como imagen principal)
*/
const CaracteristicaUnoSpcPremium = () => {
  return (
    <section className="spc-section spc-listo-section">
      <div className="container">
        <div className="row align-items-center mt-n1-6 mt-sm-n6">
          <div className="col-lg-5 mt-1-6 mt-sm-6">
            <div className="position-relative text-center text-lg-start">
              <figure className="spc-listo__main">
                <ImagenSpc
                  className="spc-listo__main-img"
                  src="/assets/img/productos/pisos-spc-premium/instalacion-flotante-spc.jpg"
                  alt="Instalación flotante del piso sobre la base"
                  width="1800"
                  height="746"
                  loading="lazy"
                />
              </figure>
              <div className="position-absolute bottom-n10 right-n10 right-lg-n30 d-none d-md-block">
                <img
                  src="/assets/img/productos/pisos-spc-premium/spc-premium-install.jpeg"
                  alt="piso spc luxury install"
                  className="spc-listo__badge-img"
                />
              </div>
            </div>
          </div>
          <div className="col-lg-7 mt-1-6 mt-sm-6">
            <div className="ps-lg-2-9 ps-xl-10">
              <div className="mb-15">
                <span className="text-primary text-uppercase small letter-spacing-4 d-block font-weight-700 mb-2">Tecnología patentada que garantiza calidad</span>
                <h2 className="mb-1-6 display-5 font-weight-800 lh-1 spc-listo__title">Listo para instalar, sin retirar la superficie anterior</h2>
              </div>
              <div className="ps-1-9 ps-sm-10 ps-lg-20">
                <p className="mb-1-6 mb-sm-2-2">
                Con entrega inmediata y colores premium, el Piso SPC Luxury es una opción confiable, elegante y altamente resistente para transformar cualquier espacio. Al instalarse de manera flotante, retirar la superficie anterior no es necesario.
                </p>
                <a href="contacto-decototal" className="butn-style4 secondary"><span>Cotiza con nosotros</span></a>
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default CaracteristicaUnoSpcPremium;